import { render } from "./DFab.vue?vue&type=template&id=54622d07&scoped=true"
import script from "./DFab.vue?vue&type=script&lang=js"
export * from "./DFab.vue?vue&type=script&lang=js"

import "./DFab.vue?vue&type=style&index=0&id=54622d07&lang=scss&scoped=true"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54622d07"]])

export default __exports__